import { createSelector, createSlice, PayloadAction } from '@reduxjs/toolkit'
import {
  createBaseSelector,
  registerSlice,
  StatusType
} from '@shared/lib/redux'

import { ProfileModel } from '../domain/profile.model'

export interface ProfileStore {
  profile: ProfileModel | null
  status: StatusType
  error: string | null
}

const initialState: ProfileStore = {
  profile: null,
  status: 'idle',
  error: null
}

const profileSlice = createSlice({
  name: 'profileSlice',
  initialState,
  reducers: {
    updateProfileStart(state) {
      state.status = 'fetching'
    },
    updateProfileSuccess(state, action: PayloadAction<ProfileModel>) {
      state.profile = action.payload
      state.status = 'success'
    },
    updateProfileFailure(state, action: PayloadAction<string>) {
      state.error = action.payload
      state.status = 'error'
    },
    setProfile: (state, action: PayloadAction<ProfileModel>) => {
      state.profile = action.payload
    },
    deleteProfile(state) {
      state.profile = null
    }
  }
})
const profileBaseSelector = createBaseSelector(profileSlice)
registerSlice([profileSlice])

const selectProfile = createSelector(profileBaseSelector, (s) => {
  return {
    profile: s.profile,
    status: s.status,
    error: s.error
  }
})

const selectStatus = createSelector(profileBaseSelector, (s) => {
  return {
    status: s.status,
    error: s.error
  }
})

export const profileStore = {
  actions: { ...profileSlice.actions },
  selectors: {
    selectProfile,
    selectStatus
  },
  name: profileSlice.name
}
